import { Component } from '@angular/core';

@Component({
  selector: 'ins-unimplemented-route',
  template: `
    <div class="container py-4 text-center">
      <h2>Page Not Found</h2>
      <p>The page you are looking for does not exist.</p>
      <a routerLink="/home" class="btn btn-warning">Go Home</a>
    </div>
  `,
})
export class UnimplementedRouteComponent {}
